import { MAX_STOCK_QUANTITY, normalizeStockQuantity } from './stock-summary';

export class InventoryValidationError extends Error {
  constructor(public readonly code: string) {
    super(code);
    this.name = 'InventoryValidationError';
  }
}

export function normalizeInventoryCountLines(
  lines: readonly { articleId: string; countedQty: number }[],
): { articleId: string; countedQty: number }[] {
  if (lines.length === 0) {
    throw new InventoryValidationError('inventory.linesRequired');
  }
  const seen = new Set<string>();
  return lines.map((line) => {
    if (!line.articleId) {
      throw new InventoryValidationError('inventory.articleRequired');
    }
    if (seen.has(line.articleId)) {
      throw new InventoryValidationError('inventory.duplicateArticle');
    }
    seen.add(line.articleId);
    const countedQty = normalizeStockQuantity(Number(line.countedQty));
    if (
      !Number.isFinite(countedQty) ||
      countedQty < 0 ||
      countedQty > MAX_STOCK_QUANTITY
    ) {
      throw new InventoryValidationError('inventory.countedQuantityInvalid');
    }
    return { articleId: line.articleId, countedQty };
  });
}

export function normalizeInitialArticleStocks(
  stockTrackingEnabled: boolean,
  stocks: readonly { warehouseId: string; quantity: number }[],
): { warehouseId: string; quantity: number }[] {
  if (!stockTrackingEnabled && stocks.length > 0) {
    throw new InventoryValidationError('article.stockTrackingRequired');
  }
  const seen = new Set<string>();
  return stocks.map((stock) => {
    if (!stock.warehouseId || seen.has(stock.warehouseId)) {
      throw new InventoryValidationError(
        'article.initialStockWarehouseInvalid',
      );
    }
    seen.add(stock.warehouseId);
    const quantity = normalizeStockQuantity(Number(stock.quantity));
    if (
      !Number.isFinite(quantity) ||
      quantity <= 0 ||
      quantity > MAX_STOCK_QUANTITY
    ) {
      throw new InventoryValidationError(
        'article.initialStockQuantityPositive',
      );
    }
    return { warehouseId: stock.warehouseId, quantity };
  });
}
